import { render, staticRenderFns } from "./ItDateInput.vue?vue&type=template&id=460c5a96&scoped=true"
import script from "./ItDateInput.vue?vue&type=script&lang=ts"
export * from "./ItDateInput.vue?vue&type=script&lang=ts"
import style0 from "./ItDateInput.vue?vue&type=style&index=0&id=460c5a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c5a96",
  null
  
)

export default component.exports